import React from "react";
import { ArrowUpRight, IdCard, Users } from "lucide-react";
import { REGISTRATION_LINKS, MEDIA } from "../../lib/constants";

export const MedicalAccess = () => {
  return (
    <section className="py-24 sm:py-32 bg-[#FAFAFA]" id="medical-access" data-testid="medical-access">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-32">
            <div className="text-[10px] uppercase tracking-[0.3em] text-brand mb-5">Medical Cannabis at District Wellness Center</div>
            <h2 className="font-serif text-5xl sm:text-6xl leading-[0.95] tracking-tight">
              Register for your<br/><em className="text-brand">medical cannabis card</em>.
            </h2>
            <p className="mt-6 text-ink-muted leading-relaxed max-w-md">
              Access premium medical cannabis products at District Wellness Center by
              registering as a medical cannabis patient in Washington, DC. We make the
              process simple so you can shop with confidence.
            </p>
            <img src={MEDIA.lounge} alt="Waiting lounge at District Wellness Center"
                 className="hidden lg:block mt-10 w-full h-64 object-cover border border-black/10" />
          </div>

          <div className="lg:col-span-8">
            <div className="grid md:grid-cols-2 gap-5">
              {/* Non-DC */}
              <article className="p-8 sm:p-10 bg-white border border-black/10 hover:border-brand transition-colors" data-testid="non-dc-card">
                <div className="flex items-center justify-between mb-8">
                  <Users size={22} className="text-brand" />
                  <span className="text-[10px] uppercase tracking-[0.3em] text-ink-muted">Visitors & Non-DC Residents</span>
                </div>
                <h3 className="font-serif text-3xl leading-tight mb-5">Visiting from another state?</h3>
                <p className="text-base text-ink-muted leading-relaxed mb-6">
                  You&rsquo;re still eligible to shop at District Wellness Center. Non-DC
                  residents can purchase medical cannabis from licensed DC dispensaries by:
                </p>
                <ul className="space-y-3 text-base">
                  <li className="flex gap-3"><span className="text-brand font-serif text-lg leading-none">✦</span> Registering for a temporary DC patient registration, or</li>
                  <li className="flex gap-3"><span className="text-brand font-serif text-lg leading-none">✦</span> Using a valid medical cannabis card issued by another state (where accepted).</li>
                </ul>
              </article>

              {/* DC */}
              <article className="p-8 sm:p-10 bg-ink text-white" data-testid="dc-card">
                <div className="flex items-center justify-between mb-8">
                  <IdCard size={22} className="text-brand" />
                  <span className="text-[10px] uppercase tracking-[0.3em] text-white/50">DC Residents</span>
                </div>
                <h3 className="font-serif text-3xl leading-tight mb-5">Live in Washington, DC?</h3>
                <p className="text-base text-white/75 leading-relaxed mb-6">
                  Register as a medical cannabis patient and shop at District Wellness Center
                  for a wide selection of premium flower, vapes, edibles, concentrates,
                  pre-rolls, tinctures, and more.
                </p>
                <ul className="space-y-3 text-base">
                  <li className="flex gap-3"><span className="text-brand font-serif text-lg leading-none">✦</span> Valid DC ID required.</li>
                  <li className="flex gap-3"><span className="text-brand font-serif text-lg leading-none">✦</span> Our team is here to help if you have any questions.</li>
                </ul>
              </article>
            </div>

            {/* Single unified CTA — myABCA portal is the sole entry point */}
            <div className="mt-8">
              <a
                href={REGISTRATION_LINKS.medical}
                target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-2 bg-brand hover:bg-brand-600 text-white px-6 py-4 text-[11px] uppercase tracking-[0.22em] transition-colors"
                data-testid="register-medical-btn"
              >
                Register for Medical Cannabis <ArrowUpRight size={14} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MedicalAccess;
